var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoT13Big(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 986,
    height: 246,
    viewBox: "0 0 986 246",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.05,
    clipPath: "url(#clip0_1396_313)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M486.26 93.2021H550.986V257.998H597.846V93.2021H662.674V54.8965H486.26V93.2021Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M713.82 92.5876H754.249V257.998H801.109V54.8965H713.82V92.5876Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M966.911 152.71C958.029 144.824 945.982 139.907 931.076 137.552L976.711 85.4192V55H835.008V92.6911H921.174L879.622 140.01V171.044H901.062C914.333 171.044 924.032 173.297 929.953 177.701C935.977 182.105 938.938 188.25 938.938 195.932C938.938 204.023 935.569 210.476 928.83 215.085C922.092 219.694 912.802 222.049 901.062 222.049C890.648 222.049 880.337 220.411 870.128 217.133C859.919 213.856 850.935 209.349 843.278 203.818L825.105 239.768C834.702 246.733 846.545 252.059 860.429 255.848C874.314 259.638 888.3 261.482 902.389 261.482C921.684 261.482 937.508 258.409 949.861 252.161C962.214 246.016 971.403 237.925 977.324 227.887C983.347 217.953 986.308 207.198 986.308 195.83C986.308 178.213 979.978 163.772 967.217 152.608L966.911 152.71Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.0543 47.9332H182.233V124.34L225.214 77.8403V47.9332H372.021L404.487 0H0L27.0543 47.9332Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.629 124.339H315.053L350.785 78.5566H243.793L201.629 124.339Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.559 136.117H242.262L182.232 209.553H249L182.232 312.999H235.933L329.448 169.814H278.709L305.559 136.117Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.2048 124.339H119.651V254.312L167.839 312.999V78.5566H55.7422L83.2048 124.339Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1396_313"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 986,
    height: 313,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoT13Big);
export default __webpack_public_path__ + "static/media/logoT13_big.ec0860259a18d2b54c8e33d79578589b.svg";
export { ForwardRef as ReactComponent };